import { FormControl, FormGroup } from '@angular/forms';
import { STATUS, TYPE } from '../constants.model';
import { SearchModel } from '../../models/search-model';

export const entitySearchModel: SearchModel = {
  label: {
    keyword: 'Keyword',
    type: 'Entity Type',
    modifiedDate: 'Modified Date',
    status: 'Status',
  },
  dataType: {
    keyword: 'string',
    type: ['select', TYPE],
    modifiedDate: 'date',
    status: ['select', STATUS],
  },
  form: new FormGroup({
    keyword: new FormControl(),
    type: new FormControl(),
    modifiedDate: new FormGroup({
      from: new FormControl(),
      to: new FormControl()
    }),
    status: new FormControl()
  }),

  query: (query) => {
    return query;
  },

  table: `bl_fi_mst_entity_hdr`,
  queryCallbacks: {
    keyword: keyword => keyword ? keyword : '',
    type: type => type ? type : '',
    status: status => status ? status : '',
    modifiedDate: modifiedDate => {
      if (modifiedDate.from || modifiedDate.to) {
        const from = modifiedDate.from ? modifiedDate.from : modifiedDate.to;
        const to = modifiedDate.to ? modifiedDate.to : modifiedDate.from;
        return `  hdr.updated_date BETWEEN '${from.format('YYYY-MM-DD HH:mm:ss')}' AND '${to.format('YYYY-MM-DD HH:mm:ss')}'`;
      }
      return '';
    },
  },
  additionalCondition: ``
};

